import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=0425c254"
import script from "./DidYouKnow.vue?vue&type=script&lang=js"
export * from "./DidYouKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports